var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6H23.0998C24.9238 6 26.6397 6.86543 27.7238 8.33225L32.4196 14.6854C33.2809 15.8507 32.449 17.5 31 17.5V17.5H24M1 17.5H24M1 45.5H18.5M24 17.5V24.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 27H38.2251C39.5903 27 40.5542 28.3374 40.1225 29.6325L36.9117 39.2649C36.3672 40.8983 34.8387 42 33.117 42H22.7239C20.8422 42 19.2149 40.6885 18.8152 38.8497L17 30.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 46,
    r: 2,
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 46,
    r: 2,
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 27V27C4.03757 27 6.5 29.4624 6.5 32.5V45.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 49,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/Commercial.4b8644afd641e1bbc42440997c38328f.svg";
export { ForwardRef as ReactComponent };